import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const GetDriver = createAsyncThunk('appBookingValidation/GetDriverList', async (GetDriver) => {
            const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverList', GetDriver, {mode:'cors'})
            return response.data
  })

  export const getVehicleType = createAsyncThunk('appBookingValidation/getVehicleType', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeList', params, {mode: 'cors'})
    return response.data
  })


  export const getClientList = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, {mode: 'cors'})
    return response.data
  })

  export const getPassengerList = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerList', params, {mode: 'cors'})
    return response.data
  })

  export const getPaymentMethodList = createAsyncThunk('appBookingValidation/getPaymentMethodList', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetPaymentMethodList')
    return response.data
  })

  export const getBookingValidationValidate = createAsyncThunk('appBookingValidation/getBookingValidataion', async (params) => {
        
    const response = await axios.post('https://api.zasway.com:8443/BookingValidation/GetBookingValidataion', params, {mode:'cors'})
     
    return {
      Validateparams : params,
      Validatedata: response.data
    }
  })

  export const getDataBookingVlidateParams = createAsyncThunk('/DispatchBookings/getDataBookingDispatchParams',  (dataParams) => {
        
   return {data : dataParams}
    
   })

  export const getBookingValidationInValidate = createAsyncThunk('appBookingValidation/getBookingValidataionInValidate', async (params) => {
         
    const response = await axios.post('https://api.zasway.com:8443/BookingValidation/GetBookingValidataion', params, {mode:'cors'})
         
    return {
      InValidateparams: params,
      InValidatedata: response.data
    }
  })

  export const storeScrollDataInStore = createAsyncThunk('/storeScrollDataInStore/storeScrollDataInStore',  (ScrollData) => {
       
    return {ScrollYx : ScrollData.ScrollData}
     
    })

  export const storeTabData = createAsyncThunk('/storeTabData/storeTabData',  (TabData) => {
     
  return {tabData :  TabData.TabData}
    
  })  
  
  export const UpdateBookingValidate = createAsyncThunk('appBookingValidation/updateBookingValidate', async (formData) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingValidation/UpdateBookingValidate', formData, {mode:'cors'})
      
    return response
  })
  export const GetCardValidation = createAsyncThunk('Client/GetCardValidation', async (booking) => {
     
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/CheckCardValidityAndDetails', booking, {mode:'cors'})
    
    return response.data
  })
  export const UpdateParamState = createAsyncThunk('appBookingValidation/UpdateParamState', async (formData) => {
          
    const response = formData
 
    return response
  })

  export const UpdateBookingValidateCalculations = createAsyncThunk('appBookingValidation/updateBookingValidatationCalculations', async (formData) => {
           
    const response = await axios.post('https://api.zasway.com:8443/BookingValidation/UpdateBookingValidatationCalculations', formData, {mode:'cors'})
       
    return response
  })
  

    export const getTaxList = createAsyncThunk('appVehicleType/getTaxList', async () => {
      const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxList')
      return response.data
    })

    export const GetVehicleTag = createAsyncThunk('appVehicleType/GetVehicleTagList', async () => {
    
      const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleTagList', {mode:'cors'})
      
      return response.data
      })

      export const UploadFile = createAsyncThunk('appVehicleType/UploadFile', async (formData) => {
         
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/UploadFile', formData, {mode:'cors'})
         
        return response
      })
      export const addVehicleType = createAsyncThunk('appVehicleType/Create', async (formData) => {
         
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/Create', formData, {mode:'cors'})
         
        return response
      })

      export const EditVehicleType = createAsyncThunk('appVehicleType/Update', async (formData) => {
         
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/Update', formData, {mode:'cors'})
        
        return response
      })

      export const getData = createAsyncThunk('appVehicle/getData', async (params) => {
         
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/GetTableSummary', params, {mode:'cors'})
          
        return {
          params,
          data: response.data.data,
          allData: response.data.allData,
          totalPages: response.data.total
        }
      })

       export const GetDriverWithSearch = createAsyncThunk('appBookingValidation/GetDriverListWithSearch', async (GetDriver) => {
            const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverListWithSearch', GetDriver, {mode:'cors'})
            return response.data
        })
       
         export const getClientListFilterWithSearch = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
          const response = await axios.post('https://api.zasway.com:8443/Common/GetClientListWithSearch', params, {mode: 'cors'})
          return response.data
        }) 

        export const getPassengerListFilterWithSearch = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
          const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerListWithSearch', params, {mode: 'cors'})
          return response.data
        })

      export const deleteVehicleType = createAsyncThunk('appVehicle/Delete', async (id, { dispatch, getState }) => {
         
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/Delete', id, {mode:'cors'})
          
        await dispatch(getData(getState().vehicleType.params))
          
        return response
      })

      export const getAllData = createAsyncThunk('appVehicle/GetTableSummary', async (GetVehicle) => {
         
      const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetTableSummary', GetVehicle, {mode:'cors'})
      
      return response
      })

  export const appBookingValidationSlice = createSlice({
    name: 'appBookingValidation',
    initialState: {
      data: [],
      total: 1,
      params: {},
      allData: [],
      Validateparams:{},
      InValidateparams:{},
      ValidateData:[],
      InValidateData:[],
      getBookingValidateParams: [],
      ScrollYx: [],
      tabData:[],
      FilterState: false
    },
    reducers: {},
    extraReducers: builder => {
      builder
      .addCase(getBookingValidationValidate.fulfilled, (state, action) => {
         
        state.ValidateData = action.payload.Validatedata
        state.Validateparams = action.payload.Validateparams
      })
      .addCase(UpdateParamState.fulfilled, (state, action) => {
         
        state.FilterState = action.payload.param
         
      })
      .addCase(getBookingValidationInValidate.fulfilled, (state, action) => {
         
        state.InValidateData = action.payload.InValidatedata
        state.InValidateparams = action.payload.InValidateparams
      })
        .addCase(getData.fulfilled, (state, action) => {
          state.data = action.payload.data
          state.allData = action.payload.allData
          state.total = action.payload.totalPages
          state.params = action.payload.params
        })

        .addCase(getDataBookingVlidateParams.fulfilled, (state, action) => {
           
          state.getBookingValidateParams = action.payload.data
         
          }) 

          .addCase(storeScrollDataInStore.fulfilled, (state, action) => {
            state.ScrollYx = action.payload.ScrollYx
            }) 

          .addCase(storeTabData.fulfilled, (state, action) => {
            state.tabData = action.payload.tabData
            })   
       
    }
  })
  
  export default appBookingValidationSlice.reducer
